module.exports = __webpack_public_path__ + "img/gw_kfqg.165bc925.png";